import React from 'react'
import Image from 'gatsby-image'
import { navigateTo } from 'gatsby-link'
import Helmet from 'react-helmet'
import LandingSection from '../../components/LandingSection'
import Section from '../../components/Section'
import Button from '../../components/Button'
import Gallery from '../../components/Gallery'
import DecoratedImage from '../../components/DecoratedImage'
import ImageWithCard from '../../components/ImageWithCard'
import specialitiesImg from '../../assets/specialities.jpg'
import Chicken from '../../components/Icons/Chicken'
import Fish from '../../components/Icons/Fish'
import Cupcake from '../../components/Icons/Cupcake'
import ContactForm from '../../components/ContactForm'
import { flattenImages } from '../../utils/images'
import Reviews from '../../components/Reviews'

import s from './styles.module.css'

const Restaurant = ({ data, i18n }) => (
  <div>
    <Helmet
      title={`${i18n('landingSectionTitle')} - Augusta Insula`}
      meta={[
        { name: 'description', content: i18n('landingSectionSubtitle') },
        {
          name: 'keywords',
          content: `lastovo restaurant, traditional food in lastovo, best placecs to eat at in Lastovo, fish restaurant, fresh food Lastovo, barbecue, barbeque, lastovo cuisine, zaklopatica, Korcula restaurant, best restaurant Korcula`
        }
      ]}
      script={[
        {
          type: 'application/ld+json',
          innerHTML: `{
          "@context": "http://schema.org",
          "@graph": [
            {
              "@context": "http://schema.org",
              "@type": "Restaurant",
              "image": [
                "https://augustainsula.com${data.restaurantImage.sizes.src}",
                "https://augustainsula.com${data.cousineImage.sizes.src}",
                "https://augustainsula.com${data.desertImage.sizes.src}",
                "https://augustainsula.com${data.veggiesImage.sizes.src}"
              ],
              "@id": "https://augustainsula.com/en/restaurant",
              "name": "Augusta Insula Lastovo Restaurant",
              "url": "https://augustainsula.com/en/restaurant",
              "openingHoursSpecification": [
                {
                  "@type": "OpeningHoursSpecification",
                  "dayOfWeek": [
                    "Monday",
                    "Tuesday",
                    "Wednesday",
                    "Thursday",
                    "Friday",
                    "Saturday",
                    "Sunday"
                  ],
                  "opens": "09:00",
                  "closes": "23:59"
                }
              ],
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Zaklopatica 21",
                "addressLocality": "Lastovo",
                "addressRegion": "Croatia",
                "telephone": "+385-98-571-884",
                "email": "info@augustainsula.com"
              },
              "menu": "https://augustainsula.com/en/restaurant",
              "acceptsReservations": true,
              "priceRange": "$$$",
              "servesCuisine": "Dalmatian, Fish, Meat, Vegan, Mediterranean, Organic, Italian, Traditional",
              "paymentAccepted": "Cash, Credit Cards",
              "email": "info@augustainsula.com",
              "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "96",
                "bestRating": "100",
                "worstRating": "1",
                "ratingCount": "173"
              },
              "review": {
                "@type": "Review",
                "url": "https://www.tripadvisor.com/ShowUserReviews-g2039687-d2206293-r505567529-Konoba_Augusta_Insula-Zaklopatica_Lastovo_Island_Dubrovnik_Neretva_County_Dalma.html",
                "author": {
                  "@type": "Person",
                  "name": "Grguru",
                  "sameAs": "https://www.tripadvisor.com/members/Grguru"
                },
                "publisher": {
                  "@type": "Organization",
                  "name": "TripAdvisor",
                  "sameAs": "https://www.tripadvisor.com"
                },
                "datePublished": "2018-07-25T20:00",
                "description": "We wanted to impress our friends and the skipper recommended Augusta Insula. They have their own dock with water and electricity which was a huge bonus for us. The dock fits about 7-8 ships, and we were in two catamarans. It was nice that we could dock together. The food was nothing short of fantastic. The appetizer included Dentex Carpaccio, a tasty home speciality zucchini pie and octopus salad. The main course was lobster and fish from Peka, with a home made cake for desert. The veggies are locally harvested and fish is freshly caught. It was so incredibly delicious. Our friends have seen the world and they all said this was their best eating experience ever. This mean the world to us and we truly appreciate the hospitality at Augusta Insula.  If you want to enjoy absolutely the best eating experience with the most amazing food and friendliest hosts, Augusta Insula is the place to go! Can't wait to go again!",
                "inLanguage": "en",
                "reviewRating": {
                  "@type": "Rating",
                  "worstRating": 1,
                  "bestRating": 5,
                  "ratingValue": 5
                }
              }
            }
          ]
        }`,
        },
      ]}
    />
    <LandingSection
      title={i18n('landingSectionTitle')}
      subtitle={i18n('landingSectionSubtitle')}
      image={data.landingImage}
    />

    <Section className={s.docking}>
      <DecoratedImage img={data.yachtImage} className={s.dockingImage} />
      <div className={s.dockingContent}>
        <h3 className={s.dockingTitle}>{i18n('yachtDocking')}</h3>
        <p>{i18n('dockingParagraph')}</p>
        <Button className={s.button} onClick={() => navigateTo('./docking')}>
          {i18n('readMore')}
        </Button>
      </div>
    </Section>

    <Section
      background={data.veggiesImage}
      text={i18n('veggieParagraph')}
      alt={i18n('veggieKeywords')}
    />

    <Section className={s.cousine}>
      <div className={s.cousineHeader}>
        <h2>{i18n('aboutCousine')}</h2>
        <p>{i18n('cousineParagraph')}</p>
      </div>
    </Section>

    <Section
      background={data.familyImage}
      text={i18n('familyText')}
      alt={i18n('familyTextKeywords')}
    />

    <Section className={s.docking}>
      <DecoratedImage img={data.wineImage} className={s.dockingImage} />
      <div className={s.dockingContent}>
        <h3 className={s.dockingTitle}>{i18n('wineTitle')}</h3>
        <p>{i18n('wineParagraph')}</p>
      </div>
    </Section>

    <Section
      background={data.restaurantImage}
      text={i18n('restaurantSectionParagraph')}
      alt={i18n('restaurantSectionKeywords')}
    />

    <Section className={s.specialitiesSection}>
      <h1 className={s.title}>{i18n('specialities')}</h1>
      <div className={s.specialities}>
        <Image
          sizes={data.specialitiesImage.sizes}
          className={s.specialitiesImg}
        />
        <div className={s.specialitiesCard}>
          <div className={s.icons}>
            <Chicken className={s.icon} />
            <Fish className={s.icon} />
            <Cupcake className={s.icon} />
          </div>
          <div className={s.menuOptions}>
            <h3 className={s.optionTitle}>{i18n('fishMenu')}</h3>
            <p>{i18n('specialitiesDescription')}</p>
            <Button className={s.button} anchor="contact-form">{i18n('bookNow')}</Button>
          </div>
        </div>
      </div>
    </Section>

    <Section>
      <h2>{i18n('foodGallery')}</h2>
      <Gallery images={flattenImages(data.galleryImages)} />
    </Section>

    <Reviews title="Reviews" image={data.testimonialsImage} />

    <Section className={s.cousine}>
      <ImageWithCard
        className={s.cousineCard}
        content={
          <div className={s.cousineContent}>
            <h3 className={s.cardTitle}>{i18n('cousineCardTitle')}</h3>
            <p>{i18n('cousineCardParagraph')}</p>
          </div>
        }
        image={data.cousineImage}
      />
    </Section>

    <ContactForm image={data.contactFormImage} />
  </div>
)

export default Restaurant

export const restaurantImagesFragment = graphql`
  fragment RestaurantImages on RootQueryType {
    landingImage: imageSharp(id: { regex: "/bg-restaurant-hero/" }) {
      sizes(maxWidth: 4080) {
        ...GatsbyImageSharpSizes_withWebp
      }
    }

    galleryImages: allFile(filter: { id: { regex: "/gallery-restaurant/" } }) {
      edges {
        node {
          image: childImageSharp {
            sizes(maxWidth: 1080) {
              ...GatsbyImageSharpSizes_withWebp
            }
          }
        }
      }
    }

    yachtImage: imageSharp(id: { regex: "/bg-from-the-sea.jpg/" }) {
      sizes(maxWidth: 2800, maxHeight: 1800) {
        ...GatsbyImageSharpSizes_withWebp
      }
    }
    
    wineImage: imageSharp(id: { regex: "/bg-wine.jpg/" }) {
      sizes(maxWidth: 2800, maxHeight: 1800) {
        ...GatsbyImageSharpSizes_withWebp
      }
    }

    cousineImage: imageSharp(id: { regex: "/cousine/" }) {
      sizes(maxWidth: 1208) {
        ...GatsbyImageSharpSizes_withWebp
      }
    }

    desertImage: imageSharp(id: { regex: "/bg-desert/" }) {
      sizes(maxWidth: 2880) {
        ...GatsbyImageSharpSizes_withWebp
      }
    }

    restaurantImage: imageSharp(id: { regex: "/bg-restaurant-terrace/" }) {
      sizes(maxWidth: 2800) {
        ...GatsbyImageSharpSizes_withWebp
      }
    }

    specialitiesImage: imageSharp(id: { regex: "/specialities-desktop.jpg/" }) {
      sizes(maxWidth: 2800) {
        ...GatsbyImageSharpSizes_withWebp
      }
    }

    contactFormImage: imageSharp(id: { regex: "/bg-peka/" }) {
      sizes(maxWidth: 2886) {
        ...GatsbyImageSharpSizes_withWebp
      }
    }

    veggiesImage: imageSharp(id: { regex: "/veggies/" }) {
      sizes(maxWidth: 2886) {
        ...GatsbyImageSharpSizes_withWebp
      }
    }

    familyImage: imageSharp(id: { regex: "/bg-shrimps/" }) {
      sizes(maxWidth: 2886) {
        ...GatsbyImageSharpSizes_withWebp
      }
    }

    testimonialsImage: imageSharp(id: { regex: "/testimonials/" }) {
      sizes(maxWidth: 1180) {
        ...GatsbyImageSharpSizes_withWebp
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/Restaurant/index.js